export class SharedContext {
    constructor() {
        this.ctx = {}
    }
    set(key, value, persist=true) {
        this.ctx[key] = value;
        if (persist) {
            localStorage.setItem(key, JSON.stringify(value));
        }
    }
    get(key) {
        if (this.ctx.hasOwnProperty(key)) {
            return this.ctx[key];
        }
        const json = localStorage.getItem(key);
        if (!json) { return null; }
        try {
            return JSON.parse(json);
        } catch (e) {
            return json;
        }
    }
    delete(key) {
        delete this.ctx[key];
        localStorage.removeItem(key);
    }
    keys() {
        return Object.keys(this.ctx);
    }
    clear(...keys) {
        if (!keys || keys.length <= 0) {
            keys = Object.keys(this.ctx);
        }
        return keys
            .map((k) => this.delete(k))
            .reduce((a, v) => (a + 1), 0);
    }
}

const sharedContext = new SharedContext();
window['shctx'] = sharedContext;

export default sharedContext;
